import React from 'react';
import {NavLink} from 'react-router-dom';
import { XMarkIcon } from '@heroicons/react/24/outline';

function NavbarClean() {
  return (
    <div className="fixed w-full bg-transparent my-0 px-4 sm:px-8 z-50">
        <div className="flex items-center justify-between py-3">
            <div className="flex justify-start lg:w-0 lg:flex-1">
                
                <NavLink to="/">
                    <span className="sr-only">Laboratorio Santa Bárbara</span>
                    <img
                        className="h-8 w-auto sm:h-10 scale-125 md:scale-150"
                        src="logo.png"
                        alt=""
                    />
                </NavLink>
            </div>

            <div className="flex justify-end lg:w-0 lg:flex-1">
                <NavLink to="/" className="inline-flex rounded-md bg-transparent text-black hover:text-black lg:text-white">
                    <span className="sr-only">Close menu</span>
                    <XMarkIcon className="h-9 w-auto sm:h-10" aria-hidden="true" />
                </NavLink>
            </div>
        </div>
    </div>
  )
}

export default NavbarClean
